export default __webpack_public_path__ + "src/images/galleries/0/btn_back_preface-a9f6f7.png";